import { createContext } from 'preact';

import { ViralLoops } from '@/lib/viral-loops';

const ReferralContext = createContext<ViralLoops | undefined>(undefined);

export default ReferralContext;
